import { cx } from "@/utils";

import styles from "./WidgetGrid.module.css";

// A 12-column grid for widgets with predefined sizes
const WidgetGrid: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <div className={styles.root}>{children}</div>;
};

export type GridSize = 12 | 8 | 7 | 6 | 5 | 4;

export const GridItem: React.FC<
  {
    size: GridSize;
    className?: string;
  } & React.HTMLProps<HTMLDivElement>
> = ({ className, size, ...props }) => (
  <div
    className={cx(className, {
      [styles.full]: size === 12,
      [styles.half]: size === 6,
      [styles.twoThirds]: size === 8,
      [styles.oneThird]: size === 4,
      [styles.sevenTwelfths]: size === 7,
      [styles.fiveTwelfths]: size === 5,
    })}
    {...props}
  />
);

export const full: GridSize = 12;
export const half: GridSize = 6;
export const oneThird: GridSize = 4;
export const twoThirds: GridSize = 8;
const fiveTwelfths: GridSize = 5;
const sevenTwelfths: GridSize = 7;

export const INSIGHTS_LAYOUT: GridSize[] = [
  full, // INSIGHTS_NUM_MENTIONS_OVER_TIME
  full, // IMPACT_SCORE
  half, // INSIGHTS_MENTIONS_REACH
  half, // INSIGHTS_TOP_CHANNELS
  full, // INSIGHTS_NUM_CHANNELS_OVER_TIME
  full, // INSIGHTS_REACH_OVER_TIME
  half, // INSIGHTS_REACH_OVER_TIME_AUDIO - This should be toggled to "full" if..
  half, // INSIGHTS_REACH_OVER_TIME_SOCIAL - ..this one is missing!
  twoThirds, // INSIGHTS_SENTIMENT_OVER_TIME_PER_MEDIA_CATEGORY
  oneThird, // INSIGHTS_SENTIMENT
  full, // INSIGHTS_WORD_CLOUD
  half, // INSIGHTS_PR_VALUE_OVER_TIME
  half, // INSIGHTS_NUM_MENTIONS_PER_MEDIA_CATEGORY
  fiveTwelfths, // INSIGHTS_MENTION_TOPICS
  sevenTwelfths, // INSIGHTS_MENTION_TOPICS_OVER_TIME
  full, // INSIGHTS_MENTIONS_PER_PEST_CATEGORY
  full, // INSIGHTS_TOP_MENTIONS
];

export const INSIGHTS_NON_SOCIALMEDIA_LAYOUT: GridSize[] = [
  full, // INSIGHTS_NUM_MENTIONS_OVER_TIME
  full, // IMPACT_SCORE
  half, // INSIGHTS_MENTIONS_REACH
  half, // INSIGHTS_TOP_CHANNELS
  full, // INSIGHTS_NUM_CHANNELS_OVER_TIME
  full, // INSIGHTS_REACH_OVER_TIME
  full, // INSIGHTS_REACH_OVER_TIME_AUDIO - Full since no reach_over_time_social
  twoThirds, // INSIGHTS_SENTIMENT_OVER_TIME_PER_MEDIA_CATEGORY
  oneThird, // INSIGHTS_SENTIMENT
  full, // INSIGHTS_WORD_CLOUD
  half, // INSIGHTS_PR_VALUE_OVER_TIME
  half, // INSIGHTS_NUM_MENTIONS_PER_MEDIA_CATEGORY
  fiveTwelfths, // INSIGHTS_MENTION_TOPICS
  sevenTwelfths, // INSIGHTS_MENTION_TOPICS_OVER_TIME
  full, // INSIGHTS_MENTIONS_PER_PEST_CATEGORY
  full, // INSIGHTS_TOP_MENTIONS
];

export default WidgetGrid;
